import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-reset-successfully',
  standalone: true,
  imports: [
    RouterLink,
  ],
  templateUrl: './reset-successfully.component.html',
  styles: ``
})
export class ResetSuccessfullyComponent {

}
